import { adminApi } from './api';
import type { FeedbackFilters, FeedbacksResponse, Feedback } from '@/types/feedback';

export const feedbackService = {
  async getFeedbacks(filters: FeedbackFilters = {}): Promise<FeedbacksResponse> {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.type) params.append('type', filters.type);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

    const response = await adminApi.get<FeedbacksResponse>(`/admin/feedbacks?${params.toString()}`);
    return response.data;
  },

  async getFeedback(id: string): Promise<Feedback> {
    const response = await adminApi.get<Feedback>(`/admin/feedbacks/${id}`);
    return response.data;
  },

  async deleteFeedback(id: string): Promise<void> {
    await adminApi.delete(`/admin/feedbacks/${id}`);
  },
};

export default feedbackService;
